import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { MANIFESTO } from "../../data/content";
import { Reveal } from "./Reveal";

function Chapter({ chapter, index }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const numY = useTransform(scrollYProgress, [0, 1], [80, -80]);
  const alignRight = index % 2 === 1;

  return (
    <div
      ref={ref}
      data-testid={`manifesto-chapter-${index}`}
      className={`relative grid grid-cols-1 lg:grid-cols-12 gap-6 items-center py-16 md:py-24 ${
        alignRight ? "lg:text-right" : ""
      }`}
    >
      <motion.span
        style={{ y: numY }}
        className={`hidden lg:block font-serif-display text-[16vw] leading-none text-foreground/[0.06] absolute top-1/2 -translate-y-1/2 pointer-events-none select-none ${
          alignRight ? "right-0" : "left-0"
        }`}
      >
        {chapter.no}
      </motion.span>

      <div
        className={`relative z-10 lg:col-span-7 ${
          alignRight ? "lg:col-start-6" : ""
        }`}
      >
        <Reveal>
          <span className="font-mono-accent text-sm text-accent">
            Reason {index + 1}
          </span>
        </Reveal>
        <Reveal delay={0.05}>
          <h3 className="mt-4 font-serif-display font-medium tracking-tight text-4xl md:text-5xl lg:text-6xl leading-[1.02]">
            {chapter.title}
          </h3>
        </Reveal>
        <Reveal delay={0.1}>
          <p
            className={`mt-6 text-base md:text-lg leading-relaxed text-foreground/75 max-w-xl ${
              alignRight ? "lg:ml-auto" : ""
            }`}
          >
            {chapter.body}
          </p>
        </Reveal>
      </div>
    </div>
  );
}

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Reveal>
          <p className="font-mono-accent text-xs uppercase tracking-[0.22em] text-accent mb-4">
            {MANIFESTO.overline}
          </p>
        </Reveal>
        <div className="border-t border-foreground/15">
          {MANIFESTO.chapters.map((c, i) => (
            <Chapter key={c.no} chapter={c} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
